export const mapNullable = (value, fn) => (value == null ? undefined : fn(value));
export const mapNullableC = (fn) => (value) => value == null ? undefined : fn(value);
